import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'urgencyLevel',
  standalone: false,
})
export class UrgencyLevelPipe implements PipeTransform {
  public static urgencyLevels = [
    { code: 'VH', name: 'High Urgency' },
    { code: 'H', name: 'High Urgency' },
    { code: 'M', name: 'Medium Urgency' },
    { code: 'L', name: 'Low Urgency' },
    { code: 'VL', name: 'Low Urgency' },
  ];

  public transform(value: string): string {
    if (value) {
      for (const urgencyLevel of UrgencyLevelPipe.urgencyLevels) {
        if (urgencyLevel.code === value) {
          return urgencyLevel.name;
        }
      }
    }
    return 'Unknown Urgency';
  }
}
